module.exports = __webpack_public_path__ + "static/img/title_ar.d619b0a3.webp";